import { createLayoutMapCache, type LayoutMapCache } from '../model/layoutMap';

/**
 * The renderer's one keyboard-layout cache. The dispatcher starts it at
 * bootstrap (via `getKeybindingLayoutMap()` in `dispatch/effectiveKeymap.ts`)
 * and the keybindings store re-validates on every published revision. It lives
 * beside the store so the store never imports the dispatch layer, which in
 * turn imports the store.
 */
export const keyboardLayoutMap: LayoutMapCache = createLayoutMapCache();
